/**
 * Which of a supervisor's teams the workspace is currently scoped to, held
 * the same way the account menu's own theme and time format hold their
 * choice: sessionStorage keyed by whoever is signed in, so switching on
 * one page (TeamSwitcher.tsx) is still in effect on the next one. There is
 * no backend column for this yet, since it is a view preference rather
 * than an organizational fact.
 */
const STORAGE_KEY = 'muster.supervisor.currentTeam'

function storageKey(userId: string): string {
  return `${STORAGE_KEY}:${userId}`
}

export function getCurrentTeamId(userId: string): string {
  try {
    return sessionStorage.getItem(storageKey(userId)) ?? ''
  } catch {
    return ''
  }
}

// Returns whether the write actually landed, the same as every other
// session store in this workspace: storage can be unavailable, and a
// switch that silently did not persist would leave the next page reading
// a stale team.
export function setCurrentTeamId(userId: string, teamId: string): boolean {
  try {
    sessionStorage.setItem(storageKey(userId), teamId)
    return true
  } catch {
    return false
  }
}
